import { render } from "./NewConversationContactsPage.vue?vue&type=template&id=a5c11fd4&scoped=true"
import script from "./NewConversationContactsPage.vue?vue&type=script&lang=js"
export * from "./NewConversationContactsPage.vue?vue&type=script&lang=js"

import "./NewConversationContactsPage.vue?vue&type=style&index=0&id=a5c11fd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c11fd4"]])

export default __exports__